/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ResourceExecutionErrorCode } from "~/generated/graphql";

export const LOG_OUTPUT_LABELS = {
  available: "Available",
  malformed: "Malformed log output",
  unavailable: "Logs unavailable",
  unavailableFilter: "Unavailable",
} as const;

export const LOG_RELATED_ERROR_CODES = [
  ResourceExecutionErrorCode.LogsMalformed,
  ResourceExecutionErrorCode.LogsNotAvailable,
] as const;

export const LOG_ERROR_CODE_FILTER_VALUES = {
  AVAILABLE: "AVAILABLE",
  UNAVAILABLE: ResourceExecutionErrorCode.LogsNotAvailable,
  MALFORMED: ResourceExecutionErrorCode.LogsMalformed,
} as const;

export const logErrorCodeCheckboxes = [
  {
    value: LOG_ERROR_CODE_FILTER_VALUES.AVAILABLE,
    label: LOG_OUTPUT_LABELS.available,
  },
  {
    value: LOG_ERROR_CODE_FILTER_VALUES.UNAVAILABLE,
    label: LOG_OUTPUT_LABELS.unavailableFilter,
  },
  {
    value: LOG_ERROR_CODE_FILTER_VALUES.MALFORMED,
    label: LOG_OUTPUT_LABELS.malformed,
  },
];
